import css from 'styled-jsx/css'

import { colors, sizes, common } from '../../theme'


export default css`
div.content :global(.container) {
  margin-top: 0;
}

div.content :global(.markdown) {
  color: ${colors.pureWhite};
  padding: 0 10rem;
}

div.content :global(.link) {
  display: block;
  margin-bottom: 80px;
}

div.content :global(.link span) {
  ${common.h3}
  color: ${colors.pureWhite};
  text-decoration: none;
}

div.content :global(.markdown *) {
  margin-bottom: 12px;
}

div.content :global(.markdown p) {
  ${common.regular16}
}

div.content :global(.markdown h4) {
  color: ${colors.yellow};
  ${common.h4}
  margin-top: 36px;
}

div.content :global(.markdown h5) {
  ${common.h5}
}

@media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
  div.content :global(.link) {
    margin-bottom: 3.6rem;
    margin-top: 1.5rem;
  }

  div.content :global(.markdown) {
    color: ${colors.pureWhite};
    padding: 0;
  }
  div.content :global(.link span) {
    ${common.h4}
  }
}

@media screen and (max-width: ${sizes.media.mobile.maxWidth}) {

}
`
